import React, { useEffect, useState } from "react";
import { Container, Tab, Tabs } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import PageHeader from "../PageHeader";
import { PageHeaderName } from "../../StyledCss/styledComponents";
import RevenueSummary from "./RevenueSummary";
import RevenueCharts from "./RevenueCharts";
import ProjectRevenueTable from "./ProjectRevenueTable";
import UserRevenueTable from "./UserRevenueTable";
import './index.css';
import { getProjects } from "../../api/services/hroneApi";
import { getRevenueSummary, getProjectRevenue, getEmployeeRevenue } from "../../api/services/hroneApi";
import { TriangleAlert } from "lucide-react";
const ProjectRevenueDashBoard = () => {
  const date = new Date();
  const [startMonth, setStartMonth] = useState(date);
  const [endMonth, setEndMonth] = useState(date);
  const [selectedProject, setSelectedProject] = useState("");
  const [revenueSummary, setRevenueSummary] = useState(null);
  const [conversionRateMissing, setConversionRateMissing] = useState(false);
  const [monthlyRevenue, setMonthlyRevenue] = useState([]);
  const [projectRevenue, setProjectRevenue] = useState([]);
  const [employeeRevenue, setEmployeeRevenue] = useState([]);
  const [activeTab, setActiveTab] = useState('projects');
  const [selectedProjectFilter, setSelectedProjectFilter] = useState(null);
  const [projectsData, setProjectsData] = useState([]);

  const getProjectsList = async () => {
    try {
      const response = await getProjects();
      if (response.ok) {
        const data = await response.json();
        setProjectsData(data);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const fetchRevenueData = async (project, startMonth, endMonth) => {
    try {
      const [summaryRes, projectRes, employeeRes] = await Promise.all([
        getRevenueSummary(project, startMonth, endMonth),
        getProjectRevenue(project, startMonth, endMonth),
        getEmployeeRevenue(project, startMonth, endMonth),
      ]);
      if (summaryRes.ok) {
        const data = await summaryRes.json();
        setRevenueSummary(data.data);
        setConversionRateMissing(data.data.conversion_rate_exists);
        setMonthlyRevenue(data.data.monthly_revenue);
      }
      if (projectRes.ok) {
        const data = await projectRes.json();
        setProjectRevenue(data.data);
      }
      if (employeeRes.ok) {
        const data = await employeeRes.json();
        setEmployeeRevenue(data.data);
      }
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };

  useEffect(() => {
    getProjectsList();
  }, []);

  useEffect(() => {
    fetchRevenueData(selectedProject, startMonth.toISOString().slice(0, 7), endMonth.toISOString().slice(0, 7));
  }, [startMonth,endMonth,selectedProject]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleProjectChange = (e) => {
    setSelectedProject(e.target.value);
  };



  const handleUserClick = async (projectId, projectName) => {
    setSelectedProjectFilter(projectName);
    setActiveTab('users');
    try {
      const employeeRes = await getEmployeeRevenue(projectId, startMonth.toISOString().slice(0, 7), endMonth.toISOString().slice(0, 7));
      if (employeeRes.ok) {
        const data = await employeeRes.json();
        setEmployeeRevenue(data.data);
      }
    } catch (error) {
      console.error("Error fetching employee revenue:", error);
    }
  };


  return (
    <div>
      <Header />
      <div className="d-flex ">
        <LeftNavBar />
        <div style={{ width: "100vw", backgroundColor: "#ededed" }}>
          <PageHeader>
            <PageHeaderName>Project Revenue </PageHeaderName>
            <select
              className="selectElement"
              value={selectedProject}
              onChange={handleProjectChange}
            >
              <option value="">All Projects</option>
              {projectsData.length === 0 ? (
                <option value="" disabled>No projects available</option>
              ) : (
                projectsData.map((project) => (
                  <option key={project.id} value={project.id}>{project.name}</option>
                ))
              )}
            </select>
          </PageHeader>
          <div className="invoice-dashboard">

      <Container className="dashboard-content">
        <div style={{display: "flex",justifyContent:"end", alignItems: 'center'}}>
          {!conversionRateMissing && (<div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        border: "1px solid #de2235",
        borderRadius: "8px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        padding: "8px 12px",
        color: "#c81313",
        backgroundColor: "#fff8f8",
        marginRight: "10px",
        marginTop: "10px",
        fontSize: "14px",
      }}
    >
      <TriangleAlert />
      <span>
        Some invoices have no conversion rate assigned. Please update them to
        ensure correct revenue calculations.
      </span>
    </div> )}
          <div className="d-flex flex-row flex-wrap justify-content-end gap-2 mb-3">
          <div className="month-picker">
            <label className="mb-1">Start Month</label>
            <DatePicker
              selected={startMonth}
              onChange={(date) => {
                if (date) {
                  setStartMonth(date);
                  if (date > endMonth) setEndMonth(date);
                } else {
                  setStartMonth(new Date());
                }
              }}
              showMonthYearPicker
              dateFormat="MMMM yyyy"
              className="date-input-label"
            />
          </div>
          <div className="month-picker">
            <label className="mb-1">End Month</label>
            <DatePicker
              selected={endMonth}
              onChange={(date) => {
                if (date) setEndMonth(date);
                else setEndMonth(new Date());
              }}
              showMonthYearPicker
              dateFormat="MMMM yyyy"
              className="date-input-label"
              minDate={startMonth}
            />
          </div>
        </div>
        </div>

        <RevenueSummary
          totalRevenue={revenueSummary?.total_revenue}
          totalProjects={revenueSummary?.total_projects}
          totalUsers={revenueSummary?.total_employees}
          pendingRevenue={revenueSummary?.pending_revenue}
          receivedRevenue={revenueSummary?.received_revenue}
          differenceRevenue={revenueSummary?.difference_revenue}
          selectedProject={selectedProject}
          pendingRevenueInvoicesData={revenueSummary?.pending_invoices}
        />

        <RevenueCharts
          monthlyData={monthlyRevenue}
          projectData={revenueSummary}
          title="Monthly Revenue"
        />

        <div className="tabs-container">
          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'projects')} className="mb-0">
            
              <Tab eventKey="projects" title="Projects">
                <ProjectRevenueTable projects={projectRevenue} onUserClick={handleUserClick}  startMonth={startMonth} endMonth={endMonth} selectedProject={selectedProject} />
              </Tab>
         
            <Tab eventKey="users" title="Employees">
              <UserRevenueTable users={employeeRevenue} filterProjectId={selectedProjectFilter} startMonth={startMonth} endMonth={endMonth} selectedProject={selectedProject} />
            </Tab>
          </Tabs>
        </div>
      </Container>
    </div>
        </div>
        
      </div>
    </div>
  );
};

export default ProjectRevenueDashBoard;